<nz-layout>
    <nz-content>
        <div class="application-landing__content">
            <nz-header class="application-landing__header" fxLayout="row" fxLayoutAlign="space-between">
                <div style="padding: 20px" fxFlex fxLayoutAlign=" center">
                    <span class="application-landing__header__title"><span class="text--bold">PIDB</span> Code Recommender</span>
                </div>
                <div>
                    <img src="assets/unicef_logo_for_background/unicef_logo_for_background.png" alt="Logo"/>
                </div>
            </nz-header>
            <div class="application-landing__content__wrap">
                <div fxFlex fxLayout="row" fxLayoutAlign="center" style="padding-top: 35vh">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="50px">
                        <span class="text--bold welcome-text">This is an AI-powered app to recommend and/or quality assure selected PIDB codes.</span>
                        <div fxLayout="row" fxLayoutAlign="center" class="p-t-15">
                            <button
                                    class="get-started-button"
                                    nz-button
                                    nzSize="large"
                                    nzType="primary"
                                    (click)="getStarted()"
                                    nzShape="round">
                                <span *ngIf="!loader">Get started!</span>
                                <nz-spin *ngIf="loader" nzSize="default" nzSimple></nz-spin>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>

